import { EyeIcon } from '@c/icons';
import type { ProductDocument } from 'models/product';
import type { OrderItemDocument } from 'models/order';
import type { AnimationControls } from 'framer-motion';
import { MotionDiv } from 'motion';
import { logEvent, getItem } from '@util/analytics';

interface QuickViewButtonProps {
  product: ProductDocument;
  setQuickViewOpen: (open: boolean) => void;
  attribution: OrderItemDocument['attribution'];
  setAttribution: (
    id: string,
    attribution: OrderItemDocument['attribution']
  ) => void;
  quickViewButtonControls: AnimationControls;
}

export const QuickViewButton = ({
  product,
  setQuickViewOpen,
  attribution,
  setAttribution,
  quickViewButtonControls,
}: QuickViewButtonProps) => {
  return (
    <MotionDiv
      className="flex cursor-pointer items-center justify-center gap-x-2 whitespace-nowrap rounded-full bg-brand-black px-8 py-4"
      initial={{ opacity: 0 }}
      animate={quickViewButtonControls}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        setQuickViewOpen(true);
        setAttribution(product.id, attribution);
        logEvent('open_quick_view', {
          items: [getItem(product)],
        });
      }}
    >
      <div className="flex items-center gap-x-2">
        <EyeIcon className="h-10 w-10 text-white" />

        <MotionDiv initial={{ opacity: 0 }} animate={quickViewButtonControls}>
          <span className="font-semibold text-white">Quick View</span>
        </MotionDiv>
      </div>
    </MotionDiv>
  );
};
